import React from 'react';
import { UseFormSetValue } from 'react-hook-form';
import styles from './Select.module.scss';
import cx from 'classnames';
import { Text } from 'components';

type Option = {
  value: string | number;
  label: string;
};

type Props = {
  labelText?: string;
  selectName: string;
  errorMsg?: string;
  canContainError?: boolean;
  options: Option[];
  register(fieldName: string, registerOptions?: { [key: string]: any }): any;
  registerOptions?: { [key: string]: any };
  setValue?: UseFormSetValue<any>;
} & React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>;

export const Select = ({
  errorMsg,
  labelText,
  selectName,
  canContainError = false,
  options,
  register,
  registerOptions,
  className,
  ...props
}: Props) => {
  return (
    <div className={cx(styles.selectItem, className, { [styles.isDisabled]: props.disabled })}>
      {labelText && (
        <label htmlFor={selectName}>
          <Text type="caption">{labelText}</Text>
        </label>
      )}
      <div className={styles.selectContainer}>
        <select name={selectName} {...register(selectName, registerOptions)} {...props}>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {canContainError && (
        <div className={styles.selectItemInfo}>
          <Text type="caption" className={styles.error}>
            {errorMsg}
          </Text>
        </div>
      )}
    </div>
  );
};
